import { Container, Typography, Box, Link } from '@mui/material';


const HomePage = () => {
    return(
        <Container maxWidth="md" sx={{ mt: 10 }}>
            <Typography paragraph variant="h4" gutterBottom>
                Welcome to LegalDescriptionConverter!
            </Typography>
            <Box sx={{ mb: 2 }}>
                <Typography paragraph>
                    I'm writing this while my 2 year old colors with washable markers. Thankfully they are of the "Ultra-Clean Washable" variety.  
                    She's got purple marker on her face. Surprise.
                </Typography>
                <Typography paragraph>
                    She is the reason I'm building these tools.
                </Typography>
                <Typography paragraph>
                    I don't want to spend anymore time than needed to get a job done.
                </Typography>
                <Typography paragraph>
                    I want to color outside the lines and get temporary multi-colored tattoos from a 2 year old.
                </Typography>
                <Typography paragraph>
                    Check out the awesome <Link href="https://geomapper.pages.dev/#/tools" target="_blank" rel="noopener noreferrer">tools</Link> we are building. They are built with the goal of creating more time with our families. 
                    Here's to hoping they help you reach your goals as we build towards ours.
                </Typography>

            </Box>
        </Container>
    )
}

export default HomePage;